import { Component, Inject, PLATFORM_ID, Input, NgModule } from '@angular/core';
import { isPlatformBrowser, CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/content-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function uid() {
    return Math.random()
        .toString(36)
        .substring(2);
}
class ContentLoaderComponent {
    /**
     * @param {?} platformId
     */
    constructor(platformId) {
        this.platformId = platformId;
        this.animate = true;
        this.baseUrl = '';
        this.width = 400;
        this.height = 130;
        this.speed = 2;
        this.preserveAspectRatio = 'xMidYMid meet';
        this.primaryColor = '#f9f9f9';
        this.secondaryColor = '#ecebeb';
        this.primaryOpacity = 1;
        this.secondaryOpacity = 1;
        this.ignoreBaseUrl = false;
        this.idClip = uid();
        this.idGradient = uid();
        this.defautlAnimation = ['-3; 1', '-2; 2', '-1; 3'];
        this.rtlAnimation = ['1; -3', '2; -2', '3; -1'];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.animationValues = this.rtl ? this.rtlAnimation : this.defautlAnimation;
        if (this.baseUrl === '' && !this.ignoreBaseUrl && isPlatformBrowser(this.platformId)) {
            this.baseUrl = window.location.pathname;
        }
        this.setFillStyle();
        this.setClipStyle();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes['baseUrl']) {
            if (changes['baseUrl'].previousValue !== changes['baseUrl'].currentValue) {
                this.setFillStyle();
                this.setClipStyle();
            }
        }
    }
    /**
     * @return {?}
     */
    setFillStyle() {
        this.fillStyle = {
            fill: `url(${this.baseUrl}#${this.idGradient})`
        };
    }
    /**
     * @return {?}
     */
    setClipStyle() {
        this.clipStyle = `url(${this.baseUrl}#${this.idClip})`;
    }
}
ContentLoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'content-loader',
                template: "<svg attr.viewBox=\"0 0 {{width}} {{height}}\" [attr.preserveAspectRatio]=\"preserveAspectRatio\" [ngStyle]=\"style\">\n\n  <rect [attr.clip-path]=\"clipStyle\" [ngStyle]=\"fillStyle\" x=\"0\" y=\"0\" [attr.width]=\"width\" [attr.height]=\"height\" />\n\n  <defs>\n\n    <clipPath [attr.id]=\"idClip\">\n      <ng-content></ng-content>\n    </clipPath>\n\n    <linearGradient [attr.id]=\"idGradient\">\n\n      <stop offset=\"0%\" [attr.stop-color]=\"primaryColor\" [attr.stop-opacity]=\"primaryOpacity\">\n        <ng-container *ngIf=\"animate\">\n          <animate attributeName=\"offset\" [attr.values]=\"animationValues[0]\" attr.dur={{speed}} s repeatCount=\"indefinite\" />\n        </ng-container>\n      </stop>\n\n      <stop offset=\"50%\" [attr.stop-color]=\"secondaryColor\" [attr.stop-opacity]=\"secondaryOpacity\">\n        <ng-container *ngIf=\"animate\">\n          <animate attributeName=\"offset\" [attr.values]=\"animationValues[1]\" attr.dur={{speed}} s repeatCount=\"indefinite\" />\n        </ng-container>\n      </stop>\n\n      <stop offset=\"100%\" [attr.stop-color]=\"primaryColor\" [attr.stop-opacity]=\"primaryOpacity\">\n        <ng-container *ngIf=\"animate\">\n          <animate attributeName=\"offset\" [attr.values]=\"animationValues[2]\" attr.dur={{speed}} s repeatCount=\"indefinite\" />\n        </ng-container>\n      </stop>\n\n    </linearGradient>\n\n  </defs>\n\n</svg>\n"
            }] }
];
/** @nocollapse */
ContentLoaderComponent.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
ContentLoaderComponent.propDecorators = {
    animate: [{ type: Input }],
    baseUrl: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    speed: [{ type: Input }],
    preserveAspectRatio: [{ type: Input }],
    primaryColor: [{ type: Input }],
    secondaryColor: [{ type: Input }],
    primaryOpacity: [{ type: Input }],
    secondaryOpacity: [{ type: Input }],
    uniqueKey: [{ type: Input }],
    rtl: [{ type: Input }],
    style: [{ type: Input }],
    ignoreBaseUrl: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ContentLoaderComponent.prototype.animate;
    /** @type {?} */
    ContentLoaderComponent.prototype.baseUrl;
    /** @type {?} */
    ContentLoaderComponent.prototype.width;
    /** @type {?} */
    ContentLoaderComponent.prototype.height;
    /** @type {?} */
    ContentLoaderComponent.prototype.speed;
    /** @type {?} */
    ContentLoaderComponent.prototype.preserveAspectRatio;
    /** @type {?} */
    ContentLoaderComponent.prototype.primaryColor;
    /** @type {?} */
    ContentLoaderComponent.prototype.secondaryColor;
    /** @type {?} */
    ContentLoaderComponent.prototype.primaryOpacity;
    /** @type {?} */
    ContentLoaderComponent.prototype.secondaryOpacity;
    /** @type {?} */
    ContentLoaderComponent.prototype.uniqueKey;
    /** @type {?} */
    ContentLoaderComponent.prototype.rtl;
    /** @type {?} */
    ContentLoaderComponent.prototype.style;
    /** @type {?} */
    ContentLoaderComponent.prototype.ignoreBaseUrl;
    /** @type {?} */
    ContentLoaderComponent.prototype.idClip;
    /** @type {?} */
    ContentLoaderComponent.prototype.idGradient;
    /** @type {?} */
    ContentLoaderComponent.prototype.defautlAnimation;
    /** @type {?} */
    ContentLoaderComponent.prototype.rtlAnimation;
    /** @type {?} */
    ContentLoaderComponent.prototype.animationValues;
    /** @type {?} */
    ContentLoaderComponent.prototype.fillStyle;
    /** @type {?} */
    ContentLoaderComponent.prototype.clipStyle;
    /**
     * @type {?}
     * @private
     */
    ContentLoaderComponent.prototype.platformId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/bullet-list-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BulletListContentLoaderComponent extends ContentLoaderComponent {
}
BulletListContentLoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'bullet-list-content-loader',
                template: `
  <content-loader [animate]="animate" [width]="width" [height]="height" [speed]="speed" [preserveAspectRatio]="preserveAspectRatio"
  [primaryColor]="primaryColor" [secondaryColor]="secondaryColor" [primaryOpacity]="primaryOpacity" [secondaryColor]="secondaryColor"
  [uniqueKey]="uniqueKey">
    <svg:circle cx="10" cy="20" r="8" />
    <svg:rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
    <svg:circle cx="10" cy="50" r="8" />
    <svg:rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
    <svg:circle cx="10" cy="80" r="8" />
    <svg:rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
    <svg:circle cx="10" cy="110" r="8" />
    <svg:rect x="25" y="105" rx="5" ry="5" width="220" height="10" />
   </content-loader>
  `
            }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/facebook-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FacebookContentLoaderComponent extends ContentLoaderComponent {
}
FacebookContentLoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'facebook-content-loader',
                template: `
  <content-loader [animate]="animate" [width]="width" [height]="height" [speed]="speed" [preserveAspectRatio]="preserveAspectRatio"
  [primaryColor]="primaryColor" [secondaryColor]="secondaryColor" [primaryOpacity]="primaryOpacity" [secondaryColor]="secondaryColor"
  [uniqueKey]="uniqueKey">
  	<svg:rect x="70" y="15" rx="4" ry="4" width="117" height="6.4" />
  	<svg:rect x="70" y="35" rx="3" ry="3" width="85" height="6.4" />
  	<svg:rect x="0" y="80" rx="3" ry="3" width="350" height="6.4" />
  	<svg:rect x="0" y="100" rx="3" ry="3" width="380" height="6.4" />
  	<svg:rect x="0" y="120" rx="3" ry="3" width="201" height="6.4" />
  	<svg:circle cx="30" cy="30" r="30" />
   </content-loader>
  `
            }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/list-loader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ListContentLoaderComponent extends ContentLoaderComponent {
}
ListContentLoaderComponent.decorators = [
    { type: Component, args: [{
                selector: 'list-content-loader',
                template: `
  <content-loader [animate]="animate" [width]="width" [height]="height" [speed]="speed" [preserveAspectRatio]="preserveAspectRatio"
  [primaryColor]="primaryColor" [secondaryColor]="secondaryColor" [primaryOpacity]="primaryOpacity" [secondaryColor]="secondaryColor"
  [uniqueKey]="uniqueKey">
  	<svg:rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
  	<svg:rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
  	<svg:rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
  	<svg:rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
  	<svg:rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
  	<svg:rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
   </content-loader>
  `
            }] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/content-loader.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ContentLoaderModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: ContentLoaderModule
        };
    }
}
ContentLoaderModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule],
                declarations: [
                    ContentLoaderComponent,
                    FacebookContentLoaderComponent,
                    BulletListContentLoaderComponent,
                    ListContentLoaderComponent
                ],
                exports: [
                    ContentLoaderComponent,
                    FacebookContentLoaderComponent,
                    BulletListContentLoaderComponent,
                    ListContentLoaderComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngneat-content-loader.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BulletListContentLoaderComponent, ContentLoaderComponent, ContentLoaderModule, FacebookContentLoaderComponent, ListContentLoaderComponent };
//# sourceMappingURL=ngneat-content-loader.js.map
